<section [formGroup]="form" class="clarification" [attr.aria-label]="label() | transloco">
	@if (locked()) {
		<h4>{{ label() | transloco }}:</h4>
		<p>
			<span>{{ 'base.field.hasBeenClarified' | transloco }}:</span
			>{{ form.controls.hasBeenClarified.value ? 'ja' : 'nein' }}
		</p>
		<p>
			<span>{{ 'base.field.clarified_at' | transloco }}:</span
			>{{ form.controls.clarifiedAt.value | date: dateDisplayFormat }}
		</p>
		<p>
			<span>{{ 'base.field.clarification_type' | transloco }}:</span
			>{{ getClarificationLabel(form.controls.typeOfClarification.value) | transloco }}
		</p>
	} @else {
		<!-- 'Has been clarified' checkbox -->
		<lvr-field [label]="showAsterisk() ? (label() | transloco | appendAsterisk) : (label() | transloco)">
			<br />
			<mat-checkbox formControlName="hasBeenClarified" [attr.aria-label]="checkboxLabel() | transloco">
				{{ checkboxLabel() | transloco }}
			</mat-checkbox>
		</lvr-field>

		<br />

		@if (form.controls.hasBeenClarified.value === true) {
			<!-- Clarification date -->
			@let clarifiedAtCtrl = form.controls.clarifiedAt;
			<lvr-field [label]="'base.field.clarified_at' | transloco | appendAsterisk">
				<mat-form-field
					lvrInput
					[lvrError]="
						hasError(clarifiedAtCtrl, 'matDatepickerParse', 'matDatepickerMin', 'matDatepickerMax', 'required')
					"
				>
					<input
						matInput
						[matDatepicker]="picker"
						formControlName="clarifiedAt"
						placeholder="01.07.2025"
						[errorStateMatcher]="matcher"
						[min]="minDate()"
						[max]="maxDate()"
					/>
					@if (hasError(clarifiedAtCtrl, 'matDatepickerParse')) {
						<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
					} @else if (hasError(clarifiedAtCtrl, 'matDatepickerMin')) {
						<mat-error>{{
							'base.form.error.date_min_error' | transloco: { minDate: (minDate() | date: dateDisplayFormat) }
						}}</mat-error>
					} @else if (hasError(clarifiedAtCtrl, 'matDatepickerMax')) {
						<mat-error>{{ 'base.form.error.date_max_error' | transloco }}</mat-error>
					} @else if (hasError(clarifiedAtCtrl, 'required')) {
						<mat-error>{{ 'base.form.error.clarified_at_required' | transloco }}</mat-error>
					} @else {
						<mat-hint>{{ dateFormatHint }}</mat-hint>
					}
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
			</lvr-field>

			<!-- Type of clarification -->
			@let clarificationTypeCtrl = form.controls.typeOfClarification;
			<lvr-field [label]="'base.field.clarification_type' | transloco | appendAsterisk">
				<mat-form-field
					lvrInput
					[attr.aria-label]="'base.field.clarification_type' | transloco"
					[lvrError]="hasError(clarificationTypeCtrl, 'required')"
				>
					<mat-select [placeholder]="'base.field.select_please' | transloco" formControlName="typeOfClarification">
						@for (option of clarificationTypes; track option.value) {
							<mat-option [value]="option.value">
								{{ option.label | transloco }}
							</mat-option>
						}
					</mat-select>
					@if (hasError(clarificationTypeCtrl, 'required')) {
						<mat-error>{{ 'base.form.error.clarification_type_required' | transloco }}</mat-error>
					}
				</mat-form-field>
			</lvr-field>
		}
	}
</section>
